module.exports = __webpack_public_path__ + "static/media/lk-templo-gangaramaya.b4dec7b1.jpg";